import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Button } from "semantic-ui-react";
import { connect as formikConnect } from "formik";
import withConfirmationModal from "../../modals/withConfirmationModal.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class FormikActionsPanel extends PureComponent {
  static CANCEL_CLICK = "ACTIONS_PANEL.CANCEL_CLICKED";
  static RESET_CLICK = "ACTIONS_PANEL.RESET_CLICKED";
  static SUBMIT_CLICK = "ACTIONS_PANEL.SUBMIT_CLICKED";

  static propTypes = {
    prev: PropTypes.bool,
    next: PropTypes.bool,
    submit: PropTypes.bool,
    reset: PropTypes.bool,

    onCancel: PropTypes.func,
    onReset: PropTypes.func,
    onSubmit: PropTypes.func,

    useSubmitModal: PropTypes.bool.isRequired,
    useResetModal: PropTypes.bool.isRequired,
    useCancelModal: PropTypes.bool.isRequired,

    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,

    panelCopy: PropTypes.object,
    modalCopy: PropTypes.object,
    entity: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    formik: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isFetching: false,
    useSubmitModal: false,
    useResetModal: true,
    useCancelModal: true
  };

  // -- HANDLERS -- //

  openCancelModal = evt => {
    const {
      isFetching,
      useCancelModal,
      formik: { dirty }
    } = this.props;

    if (isFetching) return null;

    if (useCancelModal && dirty) {
      this.configAndOpenModal(FormikActionsPanel.CANCEL_CLICK);
    } else {
      this.doCancel(evt);
    }
  };

  doCancel = evt => {
    this.doReset(evt);
    this.props.onCancel();
  };

  openResetModal = evt => {
    const {
      isFetching,
      useResetModal,
      formik: { dirty }
    } = this.props;

    if (isFetching) return null;

    if (useResetModal && dirty) {
      this.configAndOpenModal(FormikActionsPanel.RESET_CLICK);
    } else {
      this.doReset(evt);
    }
  };

  doReset = evt => {
    const { onReset, formik } = this.props;
    formik.handleReset(evt);
    if (onReset) onReset();
  };

  openSubmitModal = evt => {
    const { isFetching, useSubmitModal } = this.props;

    if (isFetching) return null;

    if (useSubmitModal) {
      this.configAndOpenModal(FormikActionsPanel.SUBMIT_CLICK);
    } else {
      this.doSubmit(evt);
    }
  };

  doSubmit = evt => {
    const { onSubmit } = this.props;
    this.props.formik.handleSubmit(evt);
    if (onSubmit) onSubmit();
  };

  // -- CONFIRMATION MODAL -- //

  configAndOpenModal = type => {
    const { entity, openModal, modalCopy, copy } = this.props;

    const copySource = modalCopy || copy("forms.confirmation_modal");

    let modalAction = null;
    let modalActiveCopy = {};

    switch (type) {
      case FormikActionsPanel.CANCEL_CLICK:
        modalActiveCopy = copySource.cancel_modal;
        modalAction = this.doCancel;
        break;
      case FormikActionsPanel.RESET_CLICK:
        modalActiveCopy = copySource.reset_modal;
        modalAction = this.doReset;
        break;
      case FormikActionsPanel.SUBMIT_CLICK:
        modalActiveCopy = copySource.submit_modal;
        modalAction = this.doSubmit;
        break;

      // using onSubmit as the default as it is least destructive
      default:
        modalActiveCopy = copySource.submit_modal;
        modalAction = this.doSubmit;
        break;
    }

    openModal(modalAction, undefined, modalActiveCopy, entity);
  };

  // -- RENDER -- //

  render() {
    const {
      prev,
      next,
      submit,
      reset,
      onNext,
      onPrev,
      onCancel,
      isFetching,
      panelCopy,
      copy
    } = this.props;

    const activeCopy = panelCopy || copy("forms.actions_panel");

    return (
      <Fragment>
        <Segment basic textAlign="right" style={{ paddingRight: "0px" }}>
          {onCancel && (
            <Button
              type="button"
              disabled={isFetching}
              onClick={this.openCancelModal}
            >
              {activeCopy.cancel}
            </Button>
          )}
          {reset && (
            <Button
              type="button"
              disabled={isFetching}
              onClick={this.openResetModal}
            >
              {activeCopy.reset}
            </Button>
          )}
          {prev && (
            <Button type="button" loading={isFetching} onClick={onPrev}>
              {activeCopy.previous}
            </Button>
          )}
          {next && (
            <Button type="submit" loading={isFetching} primary>
              {activeCopy.next}
            </Button>
          )}
          {submit && (
            <Button
              type="button"
              loading={isFetching}
              onClick={this.openSubmitModal}
              primary
            >
              {activeCopy.submit}
            </Button>
          )}
        </Segment>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(
  formikConnect(withConfirmationModal(FormikActionsPanel))
);
